/*
 * Public API Surface of common from sbe-web-v4 & sbe-web-v5
 */
import { InjectionToken } from '@angular/core';
import type { Config } from 'tailwindcss';

export const REST_SERVER_DB_SHARD_ID = new InjectionToken<string>('REST_SERVER_DB_SHARD_ID');
export const REST_SERVER_DB_SHARD_REGION = new InjectionToken<string>('REST_SERVER_DB_SHARD_REGION');
export const REST_SERVER_HOST = new InjectionToken<string>('REST_SERVER_HOST');
export const SOCKET_SERVER_HOST = new InjectionToken<string>('SOCKET_SERVER_HOST');
export const AUTH_FRONT_HOST = new InjectionToken<any>('AUTH_FRONT_HOST');
export const MAIN_FRONT_HOST = new InjectionToken<any>('MAIN_FRONT_HOST');
export const AUTH_API_HOST = new InjectionToken<any>('AUTH_API_HOST');

export const SURVEY_FRONT_HOST = new InjectionToken<string>('SURVEY_FRONT_HOST');
export const SURVEY_FRONT_HOST_V5 = new InjectionToken<string>('SURVEY_FRONT_HOST_V5');
export const SURVEY_API_HOST = new InjectionToken<string>('SURVEY_API_HOST');
export const FIREBASE_HOST = new InjectionToken<any>('FIREBASE_HOST');

export const MOBILE_HOST = new InjectionToken<any>('MOBILE_HOST');
export const SMS_HOST = new InjectionToken<any>('SMS_HOST');
export const SUPPORT_HOST = new InjectionToken<any>('SUPPORT_HOST');
export const CLASS_PROMOTION_HOST = new InjectionToken<any>('CLASS_PROMOTION_HOST');
export const SURVEY_V5_HOST = new InjectionToken<string>('SURVEY_V5_HOST');

export const REST_API_V5_HOST = new InjectionToken<string>('REST_API_V5_HOST');
export const LOGIN_HOST = new InjectionToken<string>('LOGIN_HOST');

export const TAILWIND_THEME = new InjectionToken<Config>('TAILWIND_THEME');
